const plugin = require('tailwindcss/plugin');
const tinycolor = require('tinycolor2');

const palette = {

    'grey': {
        '50': '#f7f8f9',
        '100': '#eff0f2',
        '200': '#dfe2e5',
        '300': '#c9ced3',
        '400': '#aab2ba',
        '500': '#8e99a4',
        '600': '#66727e',
        '700': '#4e5760',
        '800': '#343a40',
        '900': '#15181a'
    },
    'red': {
        '50': '#fff9fb',
        '100': '#FFEAF1',
        '200': '#FFD2E1',
        '300': '#FFA3C2',
        '400': '#FF6D9E',
        '500': '#EC004F',
        '600': '#AE003A',
        '700': '#770028',
        '800': '#460017',
        '900': '#2a000e'
    },
    'yellow': {
        '100': '#FFFAEB',
        '200': '#FEF0C7',
        '300': '#FEDF89',
        '400': '#FEC84B',
        '500': '#FDB022',
        '600': '#F79009',
        '700': '#DC6803',
        '800': '#B54708',
        '900': '#93370D'
    },
    'brown': {
        '50': '#fefdf9',
        '100': '#fcf2da',
        '200': '#f7e0a6',
        '300': '#f2cb6a',
        '400': '#e7ab15',
        '500': '#b68710',
        '600': '#906b0d',
        '700': '#77580b',
        '800': '#493607',
        '900': '#1e1603'
    },
    'green': {
        '50': '#f7fff7',
        '100': '#E7F8EF',
        '200': '#C0EED8',
        '300': '#83DCB2',
        '400': '#44C88A',
        '500': '#05B763',
        '600': '#039C54',
        '700': '#05894A' ,
        '800': '#005D32' ,
        '900': '#022E19'
    },
    'dark-green': {
        '50': '#E6F4E6',
        '100': '#BFE3BF',
        '200': '#80C780',
        '300': '#40AB40',
        '400': '#008E00',
        '500': '#007900',
        '600': '#006B00',
        '700': '#004700' ,
        '800': '#002400' ,
        '900': '#000E00'
    },
    'aqua': {
        '50': '#f2fcfe',
        '100': '#d8f5fd',
        '200': '#a8e9fb',
        '300': '#52d3f7',
        '400': '#0bb5e4',
        '500': '#0997be',
        '600': '#077b9b',
        '700': '#065e76',
        '800': '#043f4f',
        '900': '#02242d'
    },
    'blue': {
        '50': '#f7faff',
        '100': '#E7F1FE',
        '200': '#C6DDFE',
        '300': '#95C0FD',
        '400': '#67A5FC',
        '500': '#0E70FA',
        '600': '#0450BA',
        '700': '#03367D',
        '800': '#021E46',
        '900': '#011026'
    },
    'purple': {
        '50': '#fcf9ff',
        '100': '#F4ECFE',
        '200': '#E7D4FD',
        '300': '#D2AFFB',
        '400': '#BF8CF9',
        '500': '#9A4BF5',
        '600': '#700CE3',
        '700': '#4D089B',
        '800': '#2C0559',
        '900': '#1a0334'
    },
    'fuchsia': {
        '50': '#fff8fe',
        '100': '#FFE9FB',
        '200': '#FFD0F6' ,
        '300': '#FF9DEB',
        '400': '#FF5FDF',
        '500': '#D400AB',
        '600': '#A20082',
        '700': '#6f0059',
        '800': '#410034',
        '900': '#27001f'
    },
    'teal': {
        '50': '#effcfc',
        '100': '#D3F7F6',
        '200': '#98ECEB',
        '300': '#27D3D0',
        '400': '#20B1AF',
        '500': '#188583',
        '600': '#12605F',
        '700': '#0C403F' ,
        '800': '#062322' ,
        '900': '#031313'
    },
    // utilities
    'transparent': 'rgba(255,255,255,0)',
    'black': '#000',
    'white': '#fff',
};


module.exports = {
    purge: [
        './src/**/*.html',
        './src/**/*.vue',
    ],
    prefix: 'jds-',
    theme: {
        fontSize: {
            'xs': '11px',
            'sm': '12px',
            'md': '14px',
            'lg': '16px',
            '2lg': '18px',
            'xl': '24px',
            '2xl': '32px',
            '3xl': '40px',
            '4xl': '48px',
            '5xl': '64px',
        },
        fontFamily: {
            body: ['hero-new', 'Hero New', 'sans-serif'],
            mono: ['monospace']
        },
        colors: {
            ...palette,
        },
        fontWeight: {
            light: 200,
            regular: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },
        borderRadius: {
            'none': 0,
            'sm': '0.125rem',
            DEFAULT: '0.25rem',
            'md': '0.375rem',
            'lg': '0.5rem',
            'xl': '1.125rem',
            '2xl': '1.5rem',
            'full': '9999px',
        },
        extend: {
            borderWidth: {
                '3': '3px',
            }
        }
    },
    variants: {},
    plugins: []
};
